import styled from 'styled-components';
import { MakeNav, MakeNavItem } from './mixins';
export const Nav = styled.ul `
  ${props => MakeNav(props)}
`;
export const NavItem = styled.li `
  ${props => MakeNavItem(props)}
`;
